export const LOGIN = "LOGIN";
export const REQ_USER = "REQ_USER";
export const LOGOUT = "LOGOUT";
export const HOLIDAY_LIST = "HOLIDAY_LIST";
export const ADD_HOLIDAY_DATA = "ADD_HOLIDAY_DATA";
